<template>
  <v-row justify="center" v-if="haveQuestion">
    <v-dialog v-model="haveQuestion" scrollable max-width="450px">
      <v-card style="padding: 16px;">
        <v-card-title>
          <i
            style="margin-right: 14px; font-size: 14px; width: 24px; height: 24px; background: #e97ba1; color: white; border-radius: 50%; text-align: center; line-height: 24px;"
            class="lni lni-checkmark"
          ></i>
          Live ended
        </v-card-title>
        <v-card-text>You can rewatch this live soon.</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <!-- <div style="margin-right: 8px;">{{time}} seconds</div> -->
          <!-- <v-btn
            class="white--text v-btn v-btn--depressed v-size--default primary"
            color="#e97ba1"
            text
            @click="yesIam()"
          >Check Name</v-btn> -->
          <v-btn
            class="white--text v-btn v-btn--depressed v-size--default primary"
            :color="$buttonColor"
            text
            @click="backToCourse()"
          >Back to course</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
export default {
  props: ["liveDetail"],
  data() {
    return {
      dialogm1: "",
      dialog: false,
      time: 0
    };
  },
  computed: {
    endLiveNotification() {
      return this.$store.getters.endLiveNotification;
    },
    timeLeft() {
      const liveNotification = this.endLiveNotification;
      if (!liveNotification) {
        return false;
      }
      let nameCheck = localStorage.getItem("endlive");
      if (nameCheck) {
        nameCheck = JSON.parse(nameCheck);
      } else {
        nameCheck = {};
      }
      const timeLeft = this.$store.getters.dialogCountdownTime(
        liveNotification
      );

      if (timeLeft > 2000 && !nameCheck[liveNotification.term]) {
        return timeLeft;
      }
      return -1;
    },
    haveQuestion() {
      return (this.liveDetail && this.liveDetail.vdoOnDemand.length === 0) && this.timeLeft > 0;
    }
  },
  methods: {
    backToCourse() {
      const router = this.$router;
      router.go(-1);
    },
    closeDialog() {
      clearInterval(this.countdown);
      this.$store.commit("updateLiveNotification", null);
    },
    yesIam() {
      this.flushInterval();
      let nameCheck = localStorage.getItem("endlive");
      const liveNotification = this.endLiveNotification;
      let item = {};
      item[liveNotification.term] = liveNotification.timeRequest;
      if (nameCheck) {
        nameCheck = JSON.parse(nameCheck);
        item = { ...nameCheck, ...item };
      }
      localStorage.setItem("endlive", JSON.stringify(item));
      this.$store.dispatch("sendNameCheck");
    },
    minusTime() {
      if (this.time) {
        this.time -= 1;
      }
    },
    flushInterval() {
      if (this.countdown) {
        clearInterval(this.countdown);
      }
    }
  },
  watch: {
    async endLiveNotification(value) {
      this.flushInterval();
      const timeLeft = this.timeLeft;
      if (timeLeft > 0) {
        this.countdown = setInterval(async () => {
          this.time -= 1;
          if (this.time === 0) {
            await this.closeDialog();
          }
        }, 1000);
        this.time = Math.floor(timeLeft / 1000);
      }
    }
  }
};
</script>
<style scoped lang="scss">
.or-line {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #e0e0e0;
  line-height: 0.1em;
  margin: 24px auto 20px;
}
.or-line span {
  background: #fff;
  padding: 0 10px;
  /* color: #e0e0e0; */
}
@media only screen and (max-width: 768px) {
  .or-line {
    width: 100%;
  }
}
@media only screen and (min-width: 769px) and (max-width: 1024px) {
  .or-line {
    width: 100%;
  }
}
.question-container {
  padding: 24px;
}
.question {
  font-size: 15px;
  line-height: 26 (1.733);
  font-weight: 400;
}
.choice-answer {
  padding: 22px;
  margin-bottom: 24px;
  border: 1px solid #d8d8d8;
  .choice-text {
    font-size: 15px;
    font-weight: 400;
  }
  .icon-choice {
    color: #d8d8d8;
    padding-right: 19px;
  }
}
</style>

